export default __webpack_public_path__ + "static/media/helpTabLeftBranding.19e0acf4.svg";